import { HomeTitle, ContactUsInput } from "../components";
import { useLang } from "../context/LangProvider";
import { useWords,useTitle } from "../hooks";
import { FiUser } from "react-icons/fi";
import { AiOutlineMail } from "react-icons/ai";
import { IoTextOutline } from "react-icons/io5";
import { useState } from "react";

const ContactUs = () => {
	const [lang] = useLang();
	const langWords = useWords(lang);
	useTitle(langWords.contactUs || "");
	const [message, setMessage] = useState({
		firstName: "",
		lastName: "",
		email: "",
		message: "",
	});

	const updateMessage = (field, val) => {
		setMessage((prev) => ({ ...prev, [field]: val }));
	};

	const ContactUsHandler = (e) => {
		e.preventDefault();
		console.log(message);
	};

	return (
		<div style={{ marginTop: "120px" }}>
			<div className="p-4">
				<HomeTitle center title={langWords.contactUs} />
				<p className="text-center text-primary  opacity-70 max-w-md m-auto">
					{langWords.contactUsDescription}
				</p>
			</div>
			<section
				style={{ height: "650px" }}
				className="bg-gray-100 p-4 mt-32 -mb-72"
			>
				<div className="max-w-5xl m-auto flex justify-center">
					<form
						onSubmit={ContactUsHandler}
						className="bg-secondary flex-1 justify-center p-4 space-y-4 border-t-4 border-adsilVIP shadow max-w-lg rounded transform -translate-y-28"
					>
						<h3 className="text-primary text-center text-4xl font-semibold capitalize mb-8">
							{langWords.TextUs}
						</h3>
						<ContactUsInput
							icon={<FiUser />}
							value={message.firstName}
							buildMessage={(val) => updateMessage("firstName", val)}
							label={langWords.firstName}
							type="text"
						/>
						<ContactUsInput
							icon={<FiUser />}
							value={message.lastName}
							buildMessage={(val) => updateMessage("lastName", val)}
							label={langWords.lastName}
							type="text"
						/>
						<ContactUsInput
							icon={<AiOutlineMail />}
							value={message.email}
							buildMessage={(val) => updateMessage("email", val)}
							label={langWords.email}
							type="email"
						/>
						<ContactUsInput
							icon={<IoTextOutline />}
							value={message.message}
							buildMessage={(val) => updateMessage("message", val)}
							label={langWords.message}
							type="textArea"
						/>
						<div className="flex flex-col items-center justify-center space-y-4">
							<p className="text-primary opacity-60 text-center">
								{langWords.formTip}
							</p>
							<button
								type="submit"
								className="bg-primary capitalize py-2 px-8 hover:bg-opacity-80 transition rounded text-secondary cursor-pointer"
							>
								{langWords.send}
							</button>
						</div>
					</form>
					<img
						className="w-64 h-64 m-auto hidden lg:block"
						src="./assets/illustrations/contact.svg"
						alt="contact us"
					/>
				</div>
			</section>
		</div>
	);
};

export default ContactUs;
